import { testIds } from '../testConfig.utils';

export const QA_MATCH_CENTRE_SCORE_STATUS = {
  ...testIds('MATCH_CENTRE_SCORE_STATUS', {}),
};

export const QA_COUNTDOWN = {
  ...testIds('COUNTDOWN', {}),
};

export const QA_LOADING_DOTS = {
  ...testIds('LOADING_DOTS', {}),
};

export const QA_LOCALIZED_DATE = {
  ...testIds('LOCALIZED_DATE', {}),
};
